import React from "react";
import { NavLink } from "react-router-dom";
import { User } from "../types/auth";
import styles from './LeftNav.module.css';

interface LeftNavProps {
  user: User | null;
  selectedOrgID?: number | null;
  className?: string;
}

const LeftNav: React.FC<LeftNavProps> = ({ user, selectedOrgID, className = '' }) => {
  // Find the user's role in the currently selected organization
  const selectedOrgDetails = user?.organizations?.find(
    (org) => org.org_id === selectedOrgID
  );
  const orgRole = selectedOrgDetails?.role;
  
  if (!user) {
    return <div>Loading...</div>;
  }

  // Determine the CSS class based on the className prop
  // Add a global 'leftNav' class for click detection in LoggedInLayout
  const navClass = className === 'show' 
    ? `${styles.leftNav} ${styles.leftNavShow} leftNav` 
    : `${styles.leftNav} leftNav`;

  return (
    <div className={navClass}>
      <ul>
        <li>
          <NavLink to="/home" className={({ isActive }) => (isActive ? styles.active : undefined)}>
            Home
          </NavLink>
        </li>

        {/* Super Admin Section */}
        {user.sa && (
          <div>
            <h4>Super Admin</h4>
            <ul>
              <li>
                <NavLink to="/organizations" className={({ isActive }) => (isActive ? styles.active : undefined)}>
                  Organizations
                </NavLink>
              </li>
              <li>
                <NavLink to="/invites" className={({ isActive }) => (isActive ? styles.active : undefined)}>
                  Invites
                </NavLink>
              </li>
            </ul>
          </div>
        )}

        {/* Owner Section */}
        {orgRole === "owner" && (
          <>
            <li>
              <NavLink to="/members" className={({ isActive }) => (isActive ? styles.active : undefined)}>
                Members
              </NavLink>
            </li>
            <li>
              <NavLink to="/groups" className={({ isActive }) => (isActive ? styles.active : undefined)}>
                Groups
              </NavLink>
            </li>
            <li>
              <NavLink to="/curriculums" className={({ isActive }) => (isActive ? styles.active : undefined)}>
                Curriculums
              </NavLink>
            </li>
            <li>
              <NavLink to="/snippets" className={({ isActive }) => (isActive ? styles.active : undefined)}>
                Snippets
              </NavLink>
            </li>
          </>
        )}

        {/* Member Section */}
        {orgRole === "member" && (
          <>
            <li>
              <NavLink to={`/members/${user.user_id}`} className={({ isActive }) => (isActive ? styles.active : undefined)}>
                Member Page
              </NavLink>
            </li>
          </>
        )}
      </ul>
    </div>
  );
};

export default LeftNav; 